import React from 'react';
import { Search } from 'lucide-react';

const ListFilterBar = ({ fields, values, onFieldChange }) => {
  return (
    <div style={filterSectionStyle}>
      {fields.map((field) => {
        const value = values[field.key] ?? '';

        return (
          <div
            key={field.key}
            style={{
              ...filterInputGroupStyle,
              ...(field.minWidth ? { minWidth: field.minWidth } : {})
            }}
          >
            <label style={filterLabelStyle}>{field.label}</label>
            {field.type === 'search' ? (
              <div style={searchFieldWrapStyle}>
                <Search style={searchIconStyle} size={18} />
                <input
                  type="text"
                  placeholder={field.placeholder || 'Search...'}
                  value={value}
                  onChange={(e) => onFieldChange(field.key, e.target.value)}
                  style={searchInputStyle}
                />
              </div>
            ) : field.type === 'select' ? (
              <select
                value={value}
                onChange={(e) => onFieldChange(field.key, e.target.value)}
                style={filterInputStyle}
              >
                {(field.options || []).map((option) => {
                  const normalizedOption = typeof option === 'string'
                    ? { value: option, label: option }
                    : option;

                  return (
                    <option key={normalizedOption.value} value={normalizedOption.value}>
                      {normalizedOption.label}
                    </option>
                  );
                })}
              </select>
            ) : (
              <input
                type={field.type || 'text'}
                placeholder={field.placeholder || ''}
                value={value}
                onChange={(e) => onFieldChange(field.key, e.target.value)}
                style={filterInputStyle}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const filterSectionStyle = { display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' };
const filterInputGroupStyle = { display: 'flex', flexDirection: 'column', minWidth: '150px', flex: '1' };
const filterLabelStyle = { fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase' };
const filterInputStyle = { width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box' };
const searchFieldWrapStyle = { position: 'relative', width: '100%' };
const searchInputStyle = { width: '100%', padding: '8px 8px 8px 36px', borderRadius: '5px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box' };
const searchIconStyle = { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' };

export default ListFilterBar;
